module.exports = __webpack_public_path__ + "static/media/kushner-fii.509271f7.jpg";